module.exports = __webpack_public_path__ + "img/sj2@2x.4333551d.png";